export default __webpack_public_path__ + "static/media/Dr._Mandeep_Rai_AHV_In_Moms_We_Trust.c13fa89a.jpg";